<template>
  <div id="mobile_views_toggler" class="mobile-action-toggler">
    <v-menu>
      <template #activator="{ props }">
        <v-btn icon="mdi-dots-vertical" v-bind="props" size="small" color="primary"> </v-btn>
      </template>

      <v-list class="px-3">
        <v-radio-group v-model="viewValue">
          <v-list-item class="px-0" @click="() => {}">
            <v-list-item-title>
              <v-radio :key="0" :label="'Palette'" :value="'palette'"></v-radio>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="px-0" @click="() => {}">
            <v-list-item-title>
              <v-radio :key="1" :label="'Statechart Definitions'" :value="'statechartDefinitions'"></v-radio>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="px-0" @click="() => {}">
            <v-list-item-title>
              <v-radio :key="1" :label="'Properties'" :value="'properties'"></v-radio>
            </v-list-item-title>
          </v-list-item>
        </v-radio-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { UIEventBus } from "../event-bus";

const compProps = defineProps<{
  view: "palette" | "properties" | "statechartDefinitions";
}>();

const viewValue = ref<"palette" | "properties" | "statechartDefinitions">("palette");

watch(viewValue, (newVal) => {
  UIEventBus.emit("updateView", newVal);
});

watch(
  () => compProps.view,
  (newVal) => {
    viewValue.value = newVal;
  }
);

onMounted(() => {
  viewValue.value = compProps.view;
});
</script>
